/**
 * Enova Free Shipping Bar
 * Displays progress bar for free shipping threshold
 */

class EnovaFreeShippingBar {
  constructor() {
    this.config = {
      threshold: window.enovaCartConfig?.freeShippingAmount || 4900, // En centavos
      textAchieved: window.enovaCartConfig?.freeShippingText || 'Congratulations! You got free shipping!',
      textPending: window.enovaCartConfig?.freeShippingTextPending || 'You are $[amount] away from free shipping'
    };
    
    this.observer = null;
    this.init();
  }

  init() {
    // Actualizar inmediatamente
    this.update();

    // Escuchar todos los eventos posibles de actualización del carrito
    document.addEventListener('cart:updated', () => this.update());
    document.addEventListener('cart:refresh', () => this.update());
    
    // Observar cambios en el DOM del subtotal
    this.observeSubtotalChanges();
    
    // Actualizar cuando se abra el cart drawer
    this.observeCartDrawerOpen();
  }

  observeSubtotalChanges() {
    const targetNode = document.querySelector('#cart-drawer, .drawer, cart-drawer');
    if (!targetNode) {
      setTimeout(() => this.observeSubtotalChanges(), 500);
      return;
    }

    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // Verificar si cambió el subtotal
        if (mutation.target.classList?.contains('totals__subtotal-value') ||
            mutation.target.closest('.totals__subtotal-value')) {
          console.log('Subtotal changed, updating free shipping bar');
          this.update();
          break;
        }
        
        // Verificar si se agregó/eliminó un producto
        if (mutation.target.classList?.contains('cart-item') ||
            mutation.target.closest('.cart-item')) {
          console.log('Cart items changed, updating free shipping bar');
          setTimeout(() => this.update(), 100);
          break;
        }
      }
    });

    this.observer.observe(targetNode, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });

    console.log('Free shipping bar observer initialized');
  }

  observeCartDrawerOpen() {
    const cartDrawer = document.querySelector('cart-drawer, #cart-drawer');
    if (!cartDrawer) return;

    const drawerObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('is-open') || target.classList.contains('active')) {
            console.log('Cart drawer opened, updating free shipping bar');
            setTimeout(() => this.update(), 200);
          }
        }
      }
    });

    drawerObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  async update() {
    const bar = document.querySelector('.enova-free-shipping-bar');
    if (!bar) {
      console.log('Free shipping bar not found in DOM');
      return;
    }

    // Método 1: Desde el atributo data-cart-total
    let cartTotal = parseInt(bar.getAttribute('data-cart-total')) || 0;

    // Método 2: Desde el DOM del subtotal
    if (!cartTotal) {
      const totalElement = document.querySelector('.totals__subtotal-value');
      if (totalElement) {
        const totalText = totalElement.textContent.replace(/[^0-9.]/g, '');
        cartTotal = Math.round(parseFloat(totalText) * 100);
      }
    }

    // Método 3: Desde fetch al cart.js
    if (!cartTotal) {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        cartTotal = cart.total_price;
      } catch (error) {
        console.error('Error fetching cart data:', error);
      }
    }

    const fillElement = bar.querySelector('.enova-free-shipping-bar__fill');
    const textElement = bar.querySelector('.enova-free-shipping-bar__text');

    if (!fillElement || !textElement) {
      console.log('Free shipping bar elements not found');
      return;
    }

    // Calcular progreso
    const percentage = Math.min((cartTotal / this.config.threshold) * 100, 100);
    
    // Actualizar barra de progreso
    fillElement.style.width = percentage + '%';

    // Actualizar texto y atributo
    if (percentage >= 100) {
      bar.setAttribute('data-achieved', 'true');
      textElement.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        ${this.config.textAchieved}
      `;
    } else {
      bar.setAttribute('data-achieved', 'false');
      const remaining = this.config.threshold - cartTotal;
      const remainingFormatted = this.formatMoney(remaining);
      const text = this.config.textPending.replace('[amount]', remainingFormatted);
      textElement.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
        </svg>
        ${text}
      `;
    }

    console.log(`Free shipping progress: ${percentage.toFixed(1)}% (Cart total: $${(cartTotal/100).toFixed(2)})`);
  }

  formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }
}

// Inicializar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.enovaFreeShippingBar = new EnovaFreeShippingBar();
  });
} else {
  window.enovaFreeShippingBar = new EnovaFreeShippingBar();
}

